var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWateroverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5975 22C5.74752 22 1.49752 18.55 0.497522 13.8C-0.102478 11.1 0.397522 8.35002 1.89752 6.00002C3.39752 3.70002 5.69752 2.10002 8.39752 1.50002L8.89752 1.40002L11.0475 11.4L17.1475 19.65L16.7475 19.95C15.5475 20.85 14.1975 21.45 12.7475 21.75C12.0475 21.9 11.3475 22 10.5975 22ZM8.14752 2.60002C5.89752 3.20002 3.99752 4.60002 2.74752 6.55002C1.39752 8.65002 0.947522 11.15 1.44752 13.6C2.34752 17.9 6.19752 21 10.5975 21C11.2475 21 11.9475 20.95 12.5975 20.8C13.7475 20.55 14.8475 20.1 15.7975 19.45L10.1475 11.85L8.14752 2.60002Z",
    fill: "#488257"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8469 11.2L9.54688 0.35L10.0469 0.25C10.7469 0.1 11.4469 0 12.1969 0C15.3469 0 18.2469 1.4 20.2469 3.85L20.5469 4.25L11.8469 11.2ZM10.6969 1.1L12.4969 9.45L19.1969 4.15C17.3969 2.1 14.8969 1 12.1969 1C11.6969 1 11.1969 1.05 10.6969 1.1Z",
    fill: "#488257"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1453 20.55L12.6953 11.85L21.1453 5.09998L21.4453 5.49998C22.4453 6.74998 23.1453 8.19998 23.4953 9.79998C24.3453 13.75 22.7953 17.9 19.5453 20.3L19.1453 20.55ZM14.0453 12L19.3453 19.2C22.0453 17 23.2953 13.4 22.5453 9.99998C22.2453 8.69998 21.7453 7.54998 20.9953 6.49998L14.0453 12Z",
    fill: "#488257"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWateroverview);
export default __webpack_public_path__ + "static/media/wateroverview.5b46975150c9644bbffb8c7119b5ca60.svg";
export { ForwardRef as ReactComponent };